import isEmpty from 'lodash/isEmpty';
import { setStringInStorage } from '../../services/storageService';
import { activeClientConfig } from '../../services/authService';
import { Config } from '../../constants/clientConfig';

export const setClientConfigToStorage = (tenantConfig) => {
  const { uiConfigId } = tenantConfig;
  if (!isEmpty(uiConfigId)) {
    setStringInStorage(activeClientConfig, uiConfigId.split('.')[1]);
    Config.setActiveConfig = uiConfigId.split('.')[1];
  }
};
